export interface TAIDatasetEntry {
  key: string;
  features_fr?: string[];
  features_en?: string[];
  features_ar?: string[];
}

export interface TAIDatasetLessonConfig {
  bruit_fr?: string[];
  bruit_en?: string[];
  bruit_ar?: string[];
  dataset: Record<string, TAIDatasetEntry>;
}

export const createEmptyAIDatasetLessonConfig = (): TAIDatasetLessonConfig => ({
  dataset: {},
});
